module.exports = __webpack_public_path__ + "static/media/reqLoader2.c878d2f0.gif";